import type {BaseServer} from '../../../../types'

import {GridCard} from '../GridCard/GridCard'

import styles from './GridSection.module.css'

type Props = {
  mcps: BaseServer[]
}

export function GridSection(props: Props) {
  const {mcps} = props

  return (
    <section className={styles.grid}>
      {mcps.map(mcp => (
        <GridCard key={mcp.id} mcp={mcp} />
      ))}
    </section>
  )
}

try{ GridSection.displayName ||= 'GridSection' } catch {}